import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingTodayNewLayoutQuery, StaticLandingTodayNewLayoutQueryVariables, StaticLandingTodayNewSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
function StaticLandingTodayNew({
  layoutId,
  viewType
}: {
  layoutId: string;
  viewType: string;
}) {
  return <>
      <ApiErrorBoundary>
        <PageLayout id={layoutId} />
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.TodayNew],
      actionType: 'Pageview',
      actionName: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.TodayNew]}_화면`,
      customProps: {
        user_action: 'pv',
        view_type: viewType
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageCategoryFilter, PageViewCustomPropsDataKey.PageGenreFilter]} />
    </>;
}
StaticLandingTodayNew.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  if (!uidInfoList || uidInfoList.length === 0) {
    return {
      notFound: true
    };
  }
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingTodayNewLayoutQuery, StaticLandingTodayNewLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.TodayNew,
      cookie,
      uidInfoList
    });
    if (!data || !data.staticLandingTodayNewLayout) {
      throw new Error('오늘신작 고정랜딩 데이터가 없습니다.');
    }
    const layoutId = data.staticLandingTodayNewLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingTodayNewLayout
      }));
    }
    const staticLandingTodayNewSection = data.staticLandingTodayNewLayout.sections[0] as StaticLandingTodayNewSection;
    return {
      layoutId: data.staticLandingTodayNewLayout.id,
      categoryName: staticLandingTodayNewSection.categoryTabList.find(categoryInfo => categoryInfo.param === String(staticLandingTodayNewSection.param.categoryUid))?.name,
      subcategoryName: staticLandingTodayNewSection.param.subcategory?.name,
      viewType: staticLandingTodayNewSection.viewType,
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {};
  }
});
StaticLandingTodayNew.getLayout = function getLayout(page: ReactElement) {
  const {
    categoryName,
    subcategoryName
  } = page.props;
  return <Layout title={t('landing_new')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_category_filter: categoryName,
        page_genre_filter: subcategoryName
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default StaticLandingTodayNew;